import { StandaloneComponent } from '@/types/component';
import { StandaloneMarkup, StandaloneMarkupProps } from 'base/components/Markup';
import useUserAuth from 'lib/hooks/useUserAuth';
import { useUserName } from 'lib/hooks/useUserName';
import { mergeProps } from 'lib/utils/mergeProps';

export const AllasStandaloneMarkup: typeof StandaloneMarkup = ({ markup, ...props }) => {
  const { isUserLoggedIn } = useUserAuth();
  const { firstName } = useUserName();

  const showMemberMarkup = markup?.includes('id="allas-member-welcome"') && isUserLoggedIn;

  const memberMarkup = (
    <div className="bg-al-hostanemon mt-3 p-6 text-center">
      <h2 className="text-al-headline-sm mb-3">Välkommen {firstName}</h2>
      <div className="text-al-body-md">
        Vill du hantera dina print-prenumerationer?{' '}
        <a href="https://prenumerera.se/kundservice/" className="font-bold hover:underline">
          Det kan du göra här
        </a>
      </div>
    </div>
  );

  return showMemberMarkup ? (
    memberMarkup
  ) : (
    <StandaloneMarkup {...mergeProps<StandaloneMarkupProps>({ markup }, props)} />
  );
};

export default AllasStandaloneMarkup;
